// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/num/v1/num.proto (package penumbra.core.num.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * The quantity of a particular Asset. Represented as a 128-bit unsigned integer,
 * split over two fields, `lo` and `hi`, representing the low- and high-order bytes
 * of the 128-bit value, respectively. Clients must assemble these bits in their
 * implementation into a `uint128` or comparable data structure, in order to model
 * the Amount accurately.
 *
 * @generated from message penumbra.core.num.v1.Amount
 */
export class Amount extends Message {
    /**
     * @generated from field: uint64 lo = 1;
     */
    lo = protoInt64.zero;
    /**
     * @generated from field: uint64 hi = 2;
     */
    hi = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.num.v1.Amount";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "lo", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "hi", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new Amount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Amount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Amount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Amount, a, b);
    }
}
